import { PodConfigurationModel } from './../../../app/services/api/podClient';

/** Sorts editable rows by saved values so pending changes do not move them between pages. */
export const sortBySavedConfiguration = (
  configurations: PodConfigurationModel[],
  savedConfigurations: PodConfigurationModel[],
  // eslint-disable-next-line no-unused-vars
  getSortWeight: (config: PodConfigurationModel) => number,
) => {
  const getKey = (config: PodConfigurationModel) =>
    JSON.stringify([config.franchiseName, config.storeNumber, config.itemNumber]);
  const savedByKey = new Map(savedConfigurations.map(config => [getKey(config), config]));
  const getSavedWeight = (config: PodConfigurationModel) =>
    getSortWeight(savedByKey.get(getKey(config)) ?? config);

  return [...configurations].sort((a, b) => getSavedWeight(a) - getSavedWeight(b));
};

export const mergeArrays = (mainArray: PodConfigurationModel[], replacementArray: PodConfigurationModel[]) => {
  if (replacementArray.length === 0) return [...mainArray];

  return mainArray.map(item => {
    const replacementItem = replacementArray.find(x => 
      x.franchiseName === item.franchiseName && 
      x.storeNumber === item.storeNumber && 
      x.itemNumber === item.itemNumber,
    );
    
    if (replacementItem) {
      return {
        ...replacementItem,
        storeName: item.storeName,
        itemDescription: item.itemDescription,
      };
    }
    return item;
  });
};
